document.addEventListener('teeinblue-event-after-cart-added', function() {
  fetch('/cart.js', { method: 'GET' })
  .then((response) => response.json())
  .then((cart) => {
    const cartCountList = document.querySelectorAll('cart-count')
    
    cartCountList.forEach((item) => {
      if(cart.item_count > 0) {
        item.removeAttribute("hidden"); 
      }
      if (cart.item_count > 99) {
        item.innerHTML = `<span class="text-sm">99+</span>`;
        item.classList.add('cart-count--small-medium');
      } else {
        item.innerText = cart.item_count;
        item.classList.remove('cart-count--small-medium');
      }
    })
  })
  .catch((error) => {
    console.error('Error refreshing cart drawer:', error);
  });
  
  document.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true, detail: { open: true }
  }));
})